export default __webpack_public_path__ + "static/media/factory__14.9f88b182.jpg";